import React, { useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './CommonStyles.css';
import './Products.css';
import {
  Users, UserCheck, TrendingUp, Calendar, ChevronDown,
  Download, FileSpreadsheet, FileText, Printer, Phone,
  Star, BarChart2, Settings, Mail, Tag, Heart, Megaphone,
  Bell, FilePlus, Plus, Filter, Search, RotateCcw
} from 'lucide-react';

const tabs = [
  { id: 'crm', label: 'CRM' },
  { id: 'leads', label: 'Leads' },
  { id: 'followups', label: 'Follow ups' },
  { id: 'campaigns', label: 'Campaigns' },
  {
    id: 'contactslogin', label: 'Contacts Login', hasDropdown: true,
    children: ['Contacts Login', 'Commissions']
  },
  { id: 'reports', label: 'Reports' },
  { id: 'proposal_template', label: 'Proposal template' },
  { id: 'proposals', label: 'Proposals' },
  { id: 'sources', label: 'Sources' },
  { id: 'life_stage', label: 'Life Stage' },
  { id: 'followup_category', label: 'Followup Category' },
  { id: 'settings', label: 'Settings' },
];

const statCards = [
  { label: "Today's Follow ups", value: 0, icon: <Calendar size={22} color="#6366f1" />, bg: '#ede9fe' },
  { label: 'My Leads', value: 0, icon: <TrendingUp size={22} color="#3b82f6" />, bg: '#dbeafe' },
  { label: 'My leads to customer conversion', value: 0, icon: <UserCheck size={22} color="#10b981" />, bg: '#dcfce7' },
];

const followupStats = [
  { label: 'Scheduled', value: 0, color: '#6366f1' },
  { label: 'Open', value: 0, color: '#3b82f6' },
  { label: 'Cancelled', value: 0, color: '#ef4444' },
  { label: 'Completed', value: 0, color: '#22c55e' },
];

const globalStats = [
  { label: 'Customers', value: 47, icon: <Users size={20} color="#6366f1" /> },
  { label: 'Leads', value: 0, icon: <TrendingUp size={20} color="#3b82f6" /> },
  { label: 'Sources', value: 0, icon: <Tag size={20} color="#f59e0b" /> },
  { label: 'Life Stages', value: 0, icon: <Heart size={20} color="#ec4899" /> },
];

const CRM = ({ activeTab: propActiveTab }) => {
  const [activeTab, setActiveTab] = useState('crm');
  const [openDropdown, setOpenDropdown] = useState(null);

  // Synchronize internal activeTab with propActiveTab
  React.useEffect(() => {
    if (propActiveTab) {
      if (propActiveTab === 'crm_dashboard' || propActiveTab === 'crm') {
        setActiveTab('crm');
      } else if (propActiveTab === 'crm_leads') {
        setActiveTab('leads');
      } else if (propActiveTab === 'crm_followups') {
        setActiveTab('followups');
      } else if (propActiveTab === 'crm_campaigns') {
        setActiveTab('campaigns');
      } else if (propActiveTab === 'crm_contactslogin') {
        setActiveTab('contacts_login');
      } else if (propActiveTab === 'crm_commissions') {
        setActiveTab('commissions');
      } else if (propActiveTab === 'crm_reports') {
        setActiveTab('reports');
      } else if (propActiveTab === 'crm_proposal_template') {
        setActiveTab('proposal_template');
      } else if (propActiveTab === 'crm_proposals') {
        setActiveTab('proposals');
      } else if (propActiveTab === 'crm_sources') {
        setActiveTab('sources');
      } else if (propActiveTab === 'crm_life_stage') {
        setActiveTab('life_stage');
      } else if (propActiveTab === 'crm_followup_category') {
        setActiveTab('followup_category');
      } else if (propActiveTab === 'crm_settings') {
        setActiveTab('settings');
      }
    }
  }, [propActiveTab]);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [showExport2Dropdown, setShowExport2Dropdown] = useState(false);
  const [showLeadsExportDropdown, setShowLeadsExportDropdown] = useState(false);
  const [showAddLeadModal, setShowAddLeadModal] = useState(false);
  const [showAddFollowupModal, setShowAddFollowupModal] = useState(false);
  const [followupSubTab, setFollowupSubTab] = useState('followups');
  const [showFollowupFilters, setShowFollowupFilters] = useState(false);
  const [showFollowupExportDropdown, setShowFollowupExportDropdown] = useState(false);
  const [followupEntries, setFollowupEntries] = useState('25');
  const [followupSearch, setFollowupSearch] = useState('');
  
  const [dateRange] = useState('01/01/2026 - 12/31/2026');
  const [entries1, setEntries1] = useState('25');
  const [entries2, setEntries2] = useState('25');
  const [leadsEntries, setLeadsEntries] = useState('25');
  const [search1, setSearch1] = useState('');
  const [search2, setSearch2] = useState('');
  const [leadsSearch, setLeadsSearch] = useState('');
  const [campaignsSearch, setCampaignsSearch] = useState('');
  const [campaignsEntries, setCampaignsEntries] = useState('25');
  const [showAddCampaignModal, setShowAddCampaignModal] = useState(false);
  const [showCampaignExportDropdown, setShowCampaignExportDropdown] = useState(false);
  const [campaignForm, setCampaignForm] = useState({
    name: '',
    type: 'Email',
    to: '',
    subject: '',
    body: ''
  });
  
  const [showAddContactLoginModal, setShowAddContactLoginModal] = useState(false);
  const [contactLoginSearch, setContactLoginSearch] = useState('');
  const [contactLoginEntries, setContactLoginEntries] = useState('25');
  const [showContactLoginExportDropdown, setShowContactLoginExportDropdown] = useState(false);
  const [showContactLoginFilters, setShowContactLoginFilters] = useState(false);
  const [contactLoginForm, setContactLoginForm] = useState({
    contact: '',
    email: '',
    mobile: '',
    alternate: '',
    familyContact: '',
    department: '',
    designation: '',
    commission: '',
    isActive: true,
    allowLogin: true
  });
  
  const [commissionsSearch, setCommissionsSearch] = useState('');
  const [commissionsEntries, setCommissionsEntries] = useState('25');
  const [showCommissionsExportDropdown, setShowCommissionsExportDropdown] = useState(false);
  const [showCommissionsFilters, setShowCommissionsFilters] = useState(false);
  
  const [reportsSearch, setReportsSearch] = useState({ user: '', contact: '', conversion: '' });
  const [reportsEntries, setReportsEntries] = useState({ user: '25', contact: '25', conversion: '25' });
  const [showReportsExport, setShowReportsExport] = useState({ user: false, contact: false, conversion: false });
  
  const [proposalTemplatesSearch, setProposalTemplatesSearch] = useState('');
  const [proposalTemplatesEntries, setProposalTemplatesEntries] = useState('25');
  const [showAddProposalTemplateModal, setShowAddProposalTemplateModal] = useState(false);
  const [proposalTemplateForm, setProposalTemplateForm] = useState({ title: '', subject: '', body: '' });
  
  const [proposalsSearch, setProposalsSearch] = useState('');
  const [proposalsEntries, setProposalsEntries] = useState('25');
  const [showSendProposalModal, setShowSendProposalModal] = useState(false);
  const [proposalForm, setProposalForm] = useState({ recipient: '', template: '', subject: '', body: '' });
  
  const [sourcesSearch, setSourcesSearch] = useState('');
  const [sourcesEntries, setSourcesEntries] = useState('25');
  const [showAddSourceModal, setShowAddSourceModal] = useState(false);
  const [sourceForm, setSourceForm] = useState({ name: '', description: '' });
  
  const [lifeStageSearch, setLifeStageSearch] = useState('');
  const [lifeStageEntries, setLifeStageEntries] = useState('25');
  const [showAddLifeStageModal, setShowAddLifeStageModal] = useState(false);
  const [lifeStageForm, setLifeStageForm] = useState({ name: '', description: '' });
  
  const [followupCategorySearch, setFollowupCategorySearch] = useState('');
  const [followupCategoryEntries, setFollowupCategoryEntries] = useState('25');
  const [showAddFollowupCategoryModal, setShowAddFollowupCategoryModal] = useState(false);
  const [followupCategoryForm, setFollowupCategoryForm] = useState({ name: '', description: '' });
  
  const [crmSettings, setCrmSettings] = useState({
    autoAssign: true,
    defaultLeadSource: 'Website',
    followupReminder: '2',
    proposalValidity: '30',
    enableNotifications: true
  });
  
  const [leadForm, setLeadForm] = useState({
    contactType: 'Lead', contactKind: 'Individual', contactId: '',
    customerGroup: '', mobile: '', alternate: '', landline: '', email: '',
    source: '', lifeStage: '', assignedTo: []
  });

  const [followupForm, setFollowupForm] = useState({
    title: '',
    customer: '',
    status: '',
    startDatetime: '',
    endDatetime: '',
    description: '',
    followupType: '',
    followupCategory: '',
    assignedTo: [],
    sendNotification: false
  });

  const ExportDropdown = ({ show, setShow }) => (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setShow(!show)}
        style={{ background: 'var(--etpos-card)', color: 'var(--etpos-text-muted)', border: '1px solid var(--etpos-border)', padding: '0.4rem 0.9rem', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer' }}>
        <Download size={15} /> Export <ChevronDown size={13} />
      </button>
      {show && (
        <div style={{ position: 'absolute', top: '110%', right: 0, background: 'var(--etpos-card)', border: '1px solid var(--etpos-border)', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, minWidth: '170px', padding: '0.4rem 0' }}>
          {[
            { label: 'Export CSV', icon: <FileSpreadsheet size={14} color="#10b981" /> },
            { label: 'Export Excel', icon: <FileSpreadsheet size={14} color="#3b82f6" /> },
            { label: 'Print', icon: <Printer size={14} color="#6366f1" /> },
            { label: 'Export PDF', icon: <FileText size={14} color="#ef4444" /> },
          ].map((opt, i) => (
            <button key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', width: '100%', padding: '0.5rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.83rem', color: 'var(--etpos-text)', cursor: 'pointer' }}>
              {opt.icon} {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );

  const renderAddLeadModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '780px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add a new contact</h3>
          <button onClick={() => setShowAddLeadModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem', alignItems: 'start' }}>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Contact type:*</label>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
                <span style={{ padding: '0.5rem 0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}><Users size={15} /></span>
                <select value={leadForm.contactType} onChange={e => setLeadForm({ ...leadForm, contactType: e.target.value })} style={{ flex: 1, padding: '0.5rem 0.65rem', border: 'none', outline: 'none', fontSize: '0.875rem', background: 'transparent' }}>
                  <option>Lead</option><option>Customer</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', paddingTop: '1.7rem' }}>
              {['Individual', 'Business'].map(kind => (
                <label key={kind} style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: '0.875rem', color: 'var(--etpos-text)', cursor: 'pointer' }}>
                  <input type="radio" name="contactKind" value={kind} checked={leadForm.contactKind === kind} onChange={e => setLeadForm({ ...leadForm, contactKind: e.target.value })} /> {kind}
                </label>
              ))}
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Contact ID:</label>
              <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
                <span style={{ padding: '0.5rem 0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}><FileText size={15} /></span>
                <input type="text" placeholder="Contact ID" value={leadForm.contactId} onChange={e => setLeadForm({ ...leadForm, contactId: e.target.value })} style={{ flex: 1, padding: '0.5rem 0.65rem', border: 'none', outline: 'none', fontSize: '0.875rem' }} />
              </div>
              <small style={{ color: 'var(--etpos-text-muted)', fontSize: '0.78rem' }}>Leave empty to autogenerate</small>
            </div>
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Customer Group:</label>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
              <span style={{ padding: '0.5rem 0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}><Users size={15} /></span>
              <select style={{ flex: 1, padding: '0.5rem 0.65rem', border: 'none', outline: 'none', fontSize: '0.875rem', background: 'transparent' }}>
                <option value=""></option><option>Group A</option><option>Group B</option>
              </select>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(175px, 1fr))', gap: '1rem' }}>
            {[
              { label: 'Mobile:*', placeholder: 'Mobile', key: 'mobile', icon: <Phone size={14} /> },
              { label: 'Alternate number:', placeholder: 'Alternate', key: 'alternate', icon: <Phone size={14} /> },
              { label: 'Landline:', placeholder: 'Landline', key: 'landline', icon: <Phone size={14} /> },
              { label: 'Email:', placeholder: 'Email', key: 'email', icon: <Mail size={14} /> },
            ].map(field => (
              <div key={field.key}>
                <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>{field.label}</label>
                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
                  <span style={{ padding: '0.5rem 0.55rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}>{field.icon}</span>
                  <input type="text" placeholder={field.placeholder} value={leadForm[field.key]} onChange={e => setLeadForm({ ...leadForm, [field.key]: e.target.value })} style={{ flex: 1, padding: '0.5rem 0.6rem', border: 'none', outline: 'none', fontSize: '0.875rem' }} />
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
            {[{ label: 'Source:', key: 'source', icon: <TrendingUp size={14} /> }, { label: 'Life Stage:', key: 'lifeStage', icon: <Heart size={14} /> }].map(field => (
              <div key={field.key}>
                <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>{field.label}</label>
                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
                  <span style={{ padding: '0.5rem 0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}>{field.icon}</span>
                  <select style={{ flex: 1, padding: '0.5rem 0.65rem', border: 'none', outline: 'none', fontSize: '0.875rem', background: 'transparent' }}><option value="">Please Select</option></select>
                </div>
              </div>
            ))}
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Assigned to:*</label>
            <div style={{ display: 'flex', alignItems: 'flex-start', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden', minHeight: '100px' }}>
              <span style={{ padding: '0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)', alignSelf: 'stretch', display: 'flex', alignItems: 'flex-start', paddingTop: '0.9rem' }}><Users size={15} /></span>
              <div style={{ flex: 1, padding: '0.65rem 0.75rem' }}>
                {['Mr Ajay Gogia', 'Mr Pands', 'shahabaj bagwan'].map((person, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.35rem' }}>
                    <input type="checkbox" id={`assign-${i}`} /><label htmlFor={`assign-${i}`} style={{ fontSize: '0.875rem', color: 'var(--etpos-text)', cursor: 'pointer' }}>{person}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <button style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddLeadModal(false)} style={{ background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderAddCampaignModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '750px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add Campaign</h3>
          <button onClick={() => setShowAddCampaignModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Campaign Name:*</label>
              <input type="text" placeholder="Campaign Name" value={campaignForm.name} onChange={e => setCampaignForm({...campaignForm, name: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem', background: 'var(--etpos-bg)', color: 'var(--etpos-text)' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Campaign Type:*</label>
              <select value={campaignForm.type} onChange={e => setCampaignForm({...campaignForm, type: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem', background: 'var(--etpos-bg)', color: 'var(--etpos-text)' }}>
                <option value="Email">Email</option>
                <option value="SMS">SMS</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>To:*</label>
              <select value={campaignForm.to} onChange={e => setCampaignForm({...campaignForm, to: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem', background: 'var(--etpos-bg)', color: 'var(--etpos-text)' }}>
                <option value="">Please Select</option>
                <option value="all">All Contacts</option>
                <option value="leads">Leads Only</option>
                <option value="customers">Customers Only</option>
              </select>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Subject:*</label>
              <input type="text" placeholder="Subject" value={campaignForm.subject} onChange={e => setCampaignForm({...campaignForm, subject: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem', background: 'var(--etpos-bg)', color: 'var(--etpos-text)' }} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Email Body:*</label>
              <div style={{ border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
                <Editor
                  init={{
                    height: 300,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                  }}
                  value={campaignForm.body}
                  onEditorChange={(content) => setCampaignForm({...campaignForm, body: content})}
                />
              </div>
              <div style={{ marginTop: '0.5rem', textAlign: 'right' }}>
                <small style={{ color: '#94a3b8', fontSize: '0.7rem' }}>Powered by Tiny</small>
              </div>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.875rem', fontWeight: '600' }}>Available Tags:</p>
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                {['{contact_name}', '{campaign_name}', '{business_name}'].map(tag => (
                  <button key={tag} onClick={() => setCampaignForm({...campaignForm, body: campaignForm.body + tag})} style={{ padding: '0.3rem 0.6rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.75rem', color: '#4f46e5', cursor: 'pointer' }}>{tag}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: '1.25rem 2rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddCampaignModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderCampaignsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={campaignsEntries} onChange={e => setCampaignsEntries(e.target.value)}>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={campaignsSearch} onChange={e => setCampaignsSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              
              <ExportDropdown show={showCampaignExportDropdown} setShow={setShowCampaignExportDropdown} />
              
              <button className="control-btn-primary" onClick={() => setShowAddCampaignModal(true)}>
                <span className="plus-icon">+</span> Add
              </button>
            </div>
          </div>

          <div className="table-content-card" style={{ border: '1px solid var(--etpos-border)', borderRadius: '8px', overflow: 'hidden' }}>
            <div className="products-table-container">
              <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
                <thead>
                  <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                    {['Action', 'Campaign Name', 'Campaign Type', 'Created By', 'Created At'].map((h, i) => (
                      <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={5} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <Megaphone size={32} opacity={0.2} />
                        No data available in table
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAddFollowupModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '700px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.11rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add Follow up</h3>
          <button onClick={() => setShowAddFollowupModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
            <div style={{ gridColumn: '1 / -1' }}><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Title:*</label><input type="text" placeholder="Title" value={followupForm.title} onChange={e => setFollowupForm({...followupForm, title: e.target.value})} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} /></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Customer/Lead:*</label><select value={followupForm.customer} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}><option>Please Select</option></select></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Status:</label><select value={followupForm.status} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}><option>Please Select</option></select></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Start Datetime:*</label><input type="datetime-local" value={followupForm.startDatetime} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} /></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>End Datetime:*</label><input type="datetime-local" value={followupForm.endDatetime} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} /></div>
            <div style={{ gridColumn: '1 / -1' }}><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Description:</label><textarea placeholder="Description" value={followupForm.description} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem', minHeight: '80px' }} /></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Follow Up Type:*</label><select style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}><option>Please Select</option></select></div>
            <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Followup Category:*</label><select style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}><option>Please Select</option></select></div>
          </div>
          <div><label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Assigned to:*</label>
            <div style={{ display: 'flex', alignItems: 'flex-start', border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden', minHeight: '80px' }}>
              <span style={{ padding: '0.65rem', background: 'var(--etpos-bg)', borderRight: '1px solid var(--etpos-border)', color: 'var(--etpos-text-muted)' }}><Users size={15} /></span>
              <div style={{ flex: 1, padding: '0.65rem 0.75rem' }}>{['Mr Ajay Gogia', 'Mr Pands'].map((person, i) => (<div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.35rem' }}><input type="checkbox" id={`f-assign-${i}`} /> <label htmlFor={`f-assign-${i}`} style={{ fontSize: '0.875rem' }}>{person}</label></div>))}</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><input type="checkbox" id="sn" checked={followupForm.sendNotification} /> <label htmlFor="sn" style={{ fontSize: '0.875rem', fontWeight: '600' }}>Send Notification</label></div>
        </div>
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <button style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '700' }}>Save</button>
          <button onClick={() => setShowAddFollowupModal(false)} style={{ background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2rem', fontWeight: '700' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderFollowupFiltersModal = () => (
    <div className="modal-overlay" onClick={() => setShowFollowupFilters(false)}>
      <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', width: '95%' }}>
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg>Filters</h2>
          <button className="modal-close-btn" onClick={() => setShowFollowupFilters(false)}>✕</button>
        </div>
        <div className="modal-content" style={{ padding: '1.5rem' }}>
          <div className="filter-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem' }}>
            <div className="filter-group"><label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Date Range:</label><div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--etpos-border)', borderRadius: '6px', padding: '0.45rem 0.75rem', background: 'var(--etpos-bg)' }}><Calendar size={15} style={{ marginRight: '0.5rem' }} /><span style={{ fontSize: '0.85rem' }}>{dateRange}</span></div></div>
            <div className="filter-group"><label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Status:</label><select style={{ width: '100%', padding: '0.5rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.85rem' }}><option>All</option></select></div>
            <div className="filter-group"><label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Followup Category:</label><select style={{ width: '100%', padding: '0.5rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.85rem' }}><option>All</option></select></div>
          </div>
        </div>
        <div className="modal-footer" style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1.25rem', background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.875rem' }}><RotateCcw size={14} /> Reset</button>
          <button className="modal-btn close-btn" onClick={() => setShowFollowupFilters(false)} style={{ padding: '0.5rem 1.25rem', border: '1px solid var(--etpos-border)', background: 'transparent', borderRadius: '6px' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderAddContactLoginModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '700px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add Contact Login</h3>
          <button onClick={() => setShowAddContactLoginModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Contact:*</label>
              <select value={contactLoginForm.contact} onChange={e => setContactLoginForm({ ...contactLoginForm, contact: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}>
                <option>Please Select</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Email:*</label>
              <input type="email" placeholder="Email" value={contactLoginForm.email} onChange={e => setContactLoginForm({ ...contactLoginForm, email: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Mobile Number:</label>
              <input type="text" placeholder="Mobile Number" value={contactLoginForm.mobile} onChange={e => setContactLoginForm({ ...contactLoginForm, mobile: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Alternate contact number:</label>
              <input type="text" placeholder="Alternate contact number" value={contactLoginForm.alternate} onChange={e => setContactLoginForm({ ...contactLoginForm, alternate: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Family contact number:</label>
              <input type="text" placeholder="Family contact number" value={contactLoginForm.familyContact} onChange={e => setContactLoginForm({ ...contactLoginForm, familyContact: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Department:</label>
              <input type="text" placeholder="Department" value={contactLoginForm.department} onChange={e => setContactLoginForm({ ...contactLoginForm, department: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Designation:</label>
              <input type="text" placeholder="Designation" value={contactLoginForm.designation} onChange={e => setContactLoginForm({ ...contactLoginForm, designation: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.4rem', fontSize: '0.875rem' }}>Sales Commission Percentage (%):</label>
              <input type="number" placeholder="Sales Commission Percentage (%)" value={contactLoginForm.commission} onChange={e => setContactLoginForm({ ...contactLoginForm, commission: e.target.value })} style={{ width: '100%', padding: '0.55rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', fontWeight: '600' }}>
              <input type="checkbox" checked={contactLoginForm.isActive} onChange={e => setContactLoginForm({ ...contactLoginForm, isActive: e.target.checked })} /> Is active ?
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', fontWeight: '600' }}>
              <input type="checkbox" checked={contactLoginForm.allowLogin} onChange={e => setContactLoginForm({ ...contactLoginForm, allowLogin: e.target.checked })} /> Allow login
            </label>
          </div>
        </div>
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddContactLoginModal(false)} style={{ background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderContactLoginFiltersModal = () => (
    <div className="modal-overlay" onClick={() => setShowContactLoginFilters(false)}>
      <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', width: '95%' }}>
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg>Filters</h2>
          <button className="modal-close-btn" onClick={() => setShowContactLoginFilters(false)}>✕</button>
        </div>
        <div className="modal-content" style={{ padding: '1.5rem' }}>
          <div className="filter-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem' }}>
            <div className="filter-group">
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Department:</label>
              <select style={{ width: '100%', padding: '0.5rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.85rem' }}>
                <option>All</option>
              </select>
            </div>
            <div className="filter-group">
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Designation:</label>
              <select style={{ width: '100%', padding: '0.5rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.85rem' }}>
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1.25rem', background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.875rem' }}><RotateCcw size={14} /> Reset</button>
          <button className="modal-btn close-btn" onClick={() => setShowContactLoginFilters(false)} style={{ padding: '0.5rem 1.25rem', border: '1px solid var(--etpos-border)', background: 'transparent', borderRadius: '6px' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderContactsLoginTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={contactLoginEntries} onChange={e => setContactLoginEntries(e.target.value)}>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={contactLoginSearch} onChange={e => setContactLoginSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
                <button className="filter-toggle-btn" onClick={() => setShowContactLoginFilters(true)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg> Filters
                </button>
              </div>
              <ExportDropdown show={showContactLoginExportDropdown} setShow={setShowContactLoginExportDropdown} />
              <button className="control-btn-primary" onClick={() => setShowAddContactLoginModal(true)}>
                <span className="plus-icon">+</span> Add
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Contact', 'Email', 'Mobile', 'Alternate contact number', 'Family contact number', 'Department', 'Designation', 'Sales Commission Percentage (%)'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={9} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderCommissionsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={commissionsEntries} onChange={e => setCommissionsEntries(e.target.value)}>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={commissionsSearch} onChange={e => setCommissionsSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
                <button className="filter-toggle-btn" onClick={() => setShowCommissionsFilters(true)}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg> Filters
                </button>
              </div>
              <ExportDropdown show={showCommissionsExportDropdown} setShow={setShowCommissionsExportDropdown} />
              {/* No Add Button for Commissions as requested */}
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Contact', 'Total Sales Amount', 'Commission (%)', 'Total Commission', 'Paid Amount', 'Due Amount'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={6} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderCommissionsFiltersModal = () => (
    <div className="modal-overlay" onClick={() => setShowCommissionsFilters(false)}>
      <div className="modal-container filter-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', width: '95%' }}>
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg>Filters</h2>
          <button className="modal-close-btn" onClick={() => setShowCommissionsFilters(false)}>✕</button>
        </div>
        <div className="modal-content" style={{ padding: '1.5rem' }}>
          <div className="filter-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem' }}>
            <div className="filter-group">
              <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: 'var(--etpos-text-muted)', marginBottom: '0.4rem' }}>Contact:</label>
              <select style={{ width: '100%', padding: '0.5rem 0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.85rem' }}>
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1.25rem', background: 'var(--etpos-text)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.875rem' }}><RotateCcw size={14} /> Reset</button>
          <button className="modal-btn close-btn" onClick={() => setShowCommissionsFilters(false)} style={{ padding: '0.5rem 1.25rem', border: '1px solid var(--etpos-border)', background: 'transparent', borderRadius: '6px' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderReportsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
      {/* Follow ups by user */}
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border)' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700' }}>Follow ups by user</h3>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '700', marginBottom: '0.5rem' }}>Date Range:</label>
            <div style={{ width: '300px', padding: '0.5rem 0.75rem', background: '#f1f5f9', border: '1px solid var(--etpos-border)', borderRadius: '4px', fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>01/01/2026 - 12/31/2026</div>
          </div>
          
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={reportsEntries.user} onChange={e => setReportsEntries({...reportsEntries, user: e.target.value})}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <ExportDropdown show={showReportsExport.user} setShow={(val) => setShowReportsExport({...showReportsExport, user: val})} />
              <div className="tabs-search-wrapper">
                <input type="text" value={reportsSearch.user} onChange={e => setReportsSearch({...reportsSearch, user: e.target.value})} placeholder="Search..." className="tabs-search-input" />
              </div>
            </div>
          </div>

          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['User', 'Scheduled', 'Open', 'Cancelled', 'Completed', 'Others', 'Total follow ups'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={7} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>

      {/* Follow ups by contacts */}
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border)' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700' }}>Follow ups by contacts</h3>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={reportsEntries.contact} onChange={e => setReportsEntries({...reportsEntries, contact: e.target.value})}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <ExportDropdown show={showReportsExport.contact} setShow={(val) => setShowReportsExport({...showReportsExport, contact: val})} />
              <div className="tabs-search-wrapper">
                <input type="text" value={reportsSearch.contact} onChange={e => setReportsSearch({...reportsSearch, contact: e.target.value})} placeholder="Search..." className="tabs-search-input" />
              </div>
            </div>
          </div>

          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Contact', 'Scheduled', 'Open', 'Cancelled', 'Completed', 'Others', 'Total follow ups'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={7} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>

      {/* Leads to customer conversion */}
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border)' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700' }}>Leads to customer conversion</h3>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={reportsEntries.conversion} onChange={e => setReportsEntries({...reportsEntries, conversion: e.target.value})}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <ExportDropdown show={showReportsExport.conversion} setShow={(val) => setShowReportsExport({...showReportsExport, conversion: val})} />
              <div className="tabs-search-wrapper">
                <input type="text" value={reportsSearch.conversion} onChange={e => setReportsSearch({...reportsSearch, conversion: e.target.value})} placeholder="Search..." className="tabs-search-input" />
              </div>
            </div>
          </div>

          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Converted By', 'Total'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={2} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderProposalTemplateTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={proposalTemplatesEntries} onChange={e => setProposalTemplatesEntries(e.target.value)}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={proposalTemplatesSearch} onChange={e => setProposalTemplatesSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              <button className="control-btn-primary" onClick={() => setShowAddProposalTemplateModal(true)}>
                <span className="plus-icon">+</span> Add Template
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Template Name', 'Subject', 'Created By', 'Created At'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={5} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No templates found</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAddProposalTemplateModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '850px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add Proposal Template</h3>
          <button onClick={() => setShowAddProposalTemplateModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Template Name:*</label>
            <input type="text" placeholder="Template Name" value={proposalTemplateForm.title} onChange={e => setProposalTemplateForm({...proposalTemplateForm, title: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Email Subject:*</label>
            <input type="text" placeholder="Subject" value={proposalTemplateForm.subject} onChange={e => setProposalTemplateForm({...proposalTemplateForm, subject: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Template Body:*</label>
            <div style={{ border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
              <Editor
                init={{
                  height: 350,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar: 'undo redo | formatselect | ' +
                  'bold italic backcolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | help',
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                value={proposalTemplateForm.body}
                onEditorChange={(content) => setProposalTemplateForm({...proposalTemplateForm, body: content})}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.875rem', fontWeight: '600' }}>Available Tags:</p>
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                {['{contact_name}', '{business_name}', '{proposal_date}', '{total_amount}', '{items_table}'].map(tag => (
                  <button key={tag} onClick={() => setProposalTemplateForm({...proposalTemplateForm, body: proposalTemplateForm.body + tag})} style={{ padding: '0.35rem 0.75rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.75rem', color: '#4f46e5', cursor: 'pointer', fontWeight: '600' }}>{tag}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: '1.25rem 2rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 3rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddProposalTemplateModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 3rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderProposalsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={proposalsEntries} onChange={e => setProposalsEntries(e.target.value)}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={proposalsSearch} onChange={e => setProposalsSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              <button className="control-btn-primary" onClick={() => setShowSendProposalModal(true)}>
                <span className="plus-icon">+</span> Send Proposal
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Subject', 'Recipient', 'Status', 'Total Amount', 'Sent At'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={6} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No proposals found</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSendProposalModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '850px', maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Send Proposal</h3>
          <button onClick={() => setShowSendProposalModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Recipient:*</label>
              <select value={proposalForm.recipient} onChange={e => setProposalForm({...proposalForm, recipient: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem' }}>
                <option value="">Select Lead/Customer</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Template:</label>
              <select value={proposalForm.template} onChange={e => setProposalForm({...proposalForm, template: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem' }}>
                <option value="">Select Template (Optional)</option>
              </select>
            </div>
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Subject:*</label>
            <input type="text" placeholder="Subject" value={proposalForm.subject} onChange={e => setProposalForm({...proposalForm, subject: e.target.value})} style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.95rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Proposal Body:*</label>
            <div style={{ border: '1px solid var(--etpos-border)', borderRadius: '6px', overflow: 'hidden' }}>
              <Editor
                init={{
                  height: 350,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar: 'undo redo | formatselect | ' +
                  'bold italic backcolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat | help',
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                value={proposalForm.body}
                onEditorChange={(content) => setProposalForm({...proposalForm, body: content})}
              />
            </div>
          </div>
        </div>
        <div style={{ padding: '1.25rem 2rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 3rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Send Email</button>
          <button onClick={() => setShowSendProposalModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 3rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderSourcesTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={sourcesEntries} onChange={e => setSourcesEntries(e.target.value)}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={sourcesSearch} onChange={e => setSourcesSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              <button className="control-btn-primary" onClick={() => setShowAddSourceModal(true)}>
                <span className="plus-icon">+</span> Add
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Source', 'Description'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={3} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAddSourceModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '500px', maxWidth: '96vw', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add</h3>
          <button onClick={() => setShowAddSourceModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Source:*</label>
            <input type="text" placeholder="Source" value={sourceForm.name} onChange={e => setSourceForm({...sourceForm, name: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Description:</label>
            <textarea placeholder="Description" value={sourceForm.description} onChange={e => setSourceForm({...sourceForm, description: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem', minHeight: '100px', resize: 'vertical' }} />
          </div>
        </div>
        <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddSourceModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderLifeStageTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={lifeStageEntries} onChange={e => setLifeStageEntries(e.target.value)}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={lifeStageSearch} onChange={e => setLifeStageSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              <button className="control-btn-primary" onClick={() => setShowAddLifeStageModal(true)}>
                <span className="plus-icon">+</span> Add
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Life Stage', 'Description'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={3} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAddLifeStageModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '500px', maxWidth: '96vw', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add</h3>
          <button onClick={() => setShowAddLifeStageModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Life Stage:*</label>
            <input type="text" placeholder="Life Stage" value={lifeStageForm.name} onChange={e => setLifeStageForm({...lifeStageForm, name: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Description:</label>
            <textarea placeholder="Description" value={lifeStageForm.description} onChange={e => setLifeStageForm({...lifeStageForm, description: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem', minHeight: '100px', resize: 'vertical' }} />
          </div>
        </div>
        <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddLifeStageModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderFollowupCategoryTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown">
                <span>Show</span>
                <select value={followupCategoryEntries} onChange={e => setFollowupCategoryEntries(e.target.value)}>
                  <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                </select>
                <span>entries</span>
              </div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={followupCategorySearch} onChange={e => setFollowupCategorySearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
              </div>
              <button className="control-btn-primary" onClick={() => setShowAddFollowupCategoryModal(true)}>
                <span className="plus-icon">+</span> Add
              </button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Category', 'Description'].map((h, i) => (
                    <th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td colSpan={3} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderAddFollowupCategoryModal = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', width: '500px', maxWidth: '96vw', boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '1.1rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '700', color: 'var(--etpos-text)' }}>Add</h3>
          <button onClick={() => setShowAddFollowupCategoryModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.4rem', color: 'var(--etpos-text-muted)', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
        </div>
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Followup Category:*</label>
            <input type="text" placeholder="Followup Category" value={followupCategoryForm.name} onChange={e => setFollowupCategoryForm({...followupCategoryForm, name: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', color: 'var(--etpos-text)', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Description:</label>
            <textarea placeholder="Description" value={followupCategoryForm.description} onChange={e => setFollowupCategoryForm({...followupCategoryForm, description: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.9rem', minHeight: '100px', resize: 'vertical' }} />
          </div>
        </div>
        <div style={{ padding: '1.25rem 1.5rem', borderTop: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Save</button>
          <button onClick={() => setShowAddFollowupCategoryModal(false)} style={{ background: '#334155', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.6rem 2.5rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );

  const renderSettingsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem' }}>
        {/* Lead Settings */}
        <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', padding: '1.5rem' }}>
          <h4 style={{ margin: '0 0 1.25rem 0', display: 'flex', alignItems: 'center', gap: '0.6rem', color: 'var(--etpos-text)', fontSize: '1rem', fontWeight: '700' }}>
            <span style={{ background: '#eef2ff', padding: '0.4rem', borderRadius: '6px', color: '#4f46e5' }}><Users size={18} /></span> Lead Management
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ margin: 0, fontWeight: '600', fontSize: '0.9rem' }}>Auto-assign leads</p>
                <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--etpos-text-muted)' }}>Automatically assign new leads to sales team</p>
              </div>
              <input type="checkbox" checked={crmSettings.autoAssign} onChange={e => setCrmSettings({...crmSettings, autoAssign: e.target.checked})} style={{ width: '1.2rem', height: '1.2rem', cursor: 'pointer' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Default Lead Source:</label>
              <select value={crmSettings.defaultLeadSource} onChange={e => setCrmSettings({...crmSettings, defaultLeadSource: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }}>
                <option value="Website">Website</option>
                <option value="Referral">Referral</option>
                <option value="Cold Call">Cold Call</option>
              </select>
            </div>
          </div>
        </div>

        {/* Follow-up Settings */}
        <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', padding: '1.5rem' }}>
          <h4 style={{ margin: '0 0 1.25rem 0', display: 'flex', alignItems: 'center', gap: '0.6rem', color: 'var(--etpos-text)', fontSize: '1rem', fontWeight: '700' }}>
            <span style={{ background: '#fef2f2', padding: '0.4rem', borderRadius: '6px', color: '#ef4444' }}><Calendar size={18} /></span> Follow-up Preferences
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div>
              <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Reminder Time (Hours before):</label>
              <input type="number" value={crmSettings.followupReminder} onChange={e => setCrmSettings({...crmSettings, followupReminder: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ margin: 0, fontWeight: '600', fontSize: '0.9rem' }}>Enable Notifications</p>
                <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--etpos-text-muted)' }}>Browser and email alerts for follow-ups</p>
              </div>
              <input type="checkbox" checked={crmSettings.enableNotifications} onChange={e => setCrmSettings({...crmSettings, enableNotifications: e.target.checked})} style={{ width: '1.2rem', height: '1.2rem', cursor: 'pointer' }} />
            </div>
          </div>
        </div>

        {/* Proposal Settings */}
        <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', padding: '1.5rem' }}>
          <h4 style={{ margin: '0 0 1.25rem 0', display: 'flex', alignItems: 'center', gap: '0.6rem', color: 'var(--etpos-text)', fontSize: '1rem', fontWeight: '700' }}>
            <span style={{ background: '#ecfdf5', padding: '0.4rem', borderRadius: '6px', color: '#10b981' }}><FileText size={18} /></span> Proposal Defaults
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div>
              <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>Validity Period (Days):</label>
              <input type="number" value={crmSettings.proposalValidity} onChange={e => setCrmSettings({...crmSettings, proposalValidity: e.target.value})} style={{ width: '100%', padding: '0.65rem', border: '1px solid var(--etpos-border)', borderRadius: '6px', fontSize: '0.875rem' }} />
            </div>
            <p style={{ margin: 0, fontSize: '0.75rem', color: 'var(--etpos-text-muted)', fontStyle: 'italic' }}>Note: These settings apply to all new proposals created from templates.</p>
          </div>
        </div>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        <button style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.75rem 4rem', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(79, 70, 229, 0.2)' }}>Save Settings</button>
      </div>
    </div>
  );

  const renderFollowupsTab = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <div style={{ padding: '1.25rem 1.5rem' }}>
          <div style={{ display: 'flex', borderBottom: '1px solid var(--etpos-border)', marginBottom: '1.5rem' }}>
            {['Follow ups', 'Recurring Follow up'].map(tab => (
              <button key={tab} onClick={() => setFollowupSubTab(tab === 'Follow ups' ? 'followups' : 'recurring')} style={{ background: 'none', border: 'none', padding: '0.75rem 1.5rem', fontSize: '0.9rem', fontWeight: (tab === 'Follow ups' && followupSubTab === 'followups') || (tab === 'Recurring Follow up' && followupSubTab === 'recurring') ? '700' : '500', color: (tab === 'Follow ups' && followupSubTab === 'followups') || (tab === 'Recurring Follow up' && followupSubTab === 'recurring') ? 'var(--etpos-text)' : 'var(--etpos-text-muted)', borderBottom: (tab === 'Follow ups' && followupSubTab === 'followups') || (tab === 'Recurring Follow up' && followupSubTab === 'recurring') ? '2px solid #6366f1' : '2px solid transparent', cursor: 'pointer' }}>{tab}</button>
            ))}
          </div>
          <div className="table-controls" style={{ padding: '0 0 1.25rem 0' }}>
            <div className="table-controls-left">
              <div className="entries-dropdown"><span>Show</span><select value={followupEntries} onChange={e => setFollowupEntries(e.target.value)}><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select><span>entries</span></div>
            </div>
            <div className="table-controls-right">
              <div className="tabs-search-wrapper">
                <input type="text" value={followupSearch} onChange={e => setFollowupSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" />
                <button className="filter-toggle-btn" onClick={() => setShowFollowupFilters(!showFollowupFilters)}><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" /></svg> Filters</button>
              </div>
              <div style={{ position: 'relative' }}>
                <button className="export-btn" onClick={() => setShowFollowupExportDropdown(!showFollowupExportDropdown)}><Download size={14} style={{ marginRight: '0.4rem' }} /> Export ▾</button>
                {showFollowupExportDropdown && (
                  <div className="export-dropdown-menu">
                    <button onClick={() => setShowFollowupExportDropdown(false)}><FileSpreadsheet size={14} color="#10b981" /> Export CSV</button>
                    <button onClick={() => setShowFollowupExportDropdown(false)}><FileSpreadsheet size={14} color="#3b82f6" /> Export Excel</button>
                    <button onClick={() => setShowFollowupExportDropdown(false)}><Printer size={14} color="#6366f1" /> Print</button>
                    <button onClick={() => setShowFollowupExportDropdown(false)}><FileText size={14} color="#ef4444" /> Export PDF</button>
                  </div>
                )}
              </div>
              <button className="control-btn-primary" onClick={() => setShowAddFollowupModal(true)}><span className="plus-icon">+</span> Add</button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
              <thead>
                <tr style={{ background: 'var(--etpos-bg)', borderBottom: '2px solid var(--etpos-border)' }}>
                  {['Action', 'Contact', 'Start', 'End', 'Status', 'Type', 'Category', 'Assigned to', 'Description', 'Info', 'Title'].map((h, i) => (<th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: '700' }}>{h}</th>))}
                </tr>
              </thead>
              <tbody><tr><td colSpan={11} style={{ padding: '3.5rem', textAlign: 'center', color: 'var(--etpos-text-muted)' }}>No data available in table</td></tr></tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem' }}>
            <span style={{ fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Showing 0 to 0 of 0 entries</span>
            <div style={{ display: 'flex', gap: '0.25rem' }}>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Previous</button>
              <button style={{ padding: '0.45rem 0.85rem', border: '1px solid var(--etpos-border)', background: '#fff', borderRadius: '4px', cursor: 'not-allowed' }}>Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="crm-container">
      <div className="main-card">


        <div className="crm-content" style={{ padding: '1.5rem' }}>
          {activeTab === 'crm' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '1rem', marginBottom: '1.25rem' }}>
                {statCards.map((card, i) => (<div key={i} style={{ background: 'var(--etpos-bg)', border: '1px solid var(--etpos-border)', borderRadius: '10px', padding: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem' }}><div style={{ background: card.bg, borderRadius: '10px', padding: '0.65rem' }}>{card.icon}</div><div><p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--etpos-text-muted)' }}>{card.label}</p><p style={{ margin: '0.2rem 0 0', fontSize: '1.6rem', fontWeight: '800' }}>{card.value}</p></div></div>))}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.25rem' }}>
                <div style={{ background: 'var(--etpos-bg)', border: '1px solid var(--etpos-border)', borderRadius: '10px', padding: '1.25rem' }}><h4>My Follow ups</h4><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>{followupStats.map((f, i) => (<div key={i} style={{ background: 'var(--etpos-card)', border: '1px solid var(--etpos-border)', borderRadius: '8px', padding: '0.85rem 1rem', display: 'flex', justifyContent: 'space-between' }}><span>{f.label}</span><span style={{ color: f.color, fontWeight: '800' }}>{f.value}</span></div>))}</div></div>
                <div style={{ background: 'var(--etpos-bg)', border: '1px solid var(--etpos-border)', borderRadius: '10px', padding: '1.25rem' }}><h4>Overview</h4><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>{globalStats.map((g, i) => (<div key={i} style={{ background: 'var(--etpos-card)', border: '1px solid var(--etpos-border)', borderRadius: '8px', padding: '0.85rem 1rem', display: 'flex', justifyContent: 'space-between' }}><span>{g.label}</span><span style={{ fontWeight: '800' }}>{g.value}</span></div>))}</div></div>
              </div>
            </div>
          )}

          {activeTab === 'leads' && (
            <div>
              <div className="table-controls" style={{ marginBottom: '1rem' }}>
                <div className="table-controls-left"><div className="entries-dropdown"><span>Show</span><select value={leadsEntries} onChange={e => setLeadsEntries(e.target.value)}><option>25</option></select><span>entries</span></div></div>
                <div className="table-controls-right"><div className="tabs-search-wrapper"><input type="text" value={leadsSearch} onChange={e => setLeadsSearch(e.target.value)} placeholder="Search..." className="tabs-search-input" /></div><ExportDropdown show={showLeadsExportDropdown} setShow={setShowLeadsExportDropdown} /><button onClick={() => setShowAddLeadModal(true)} className="control-btn-primary">+ Add</button></div>
              </div>
              <div style={{ overflowX: 'auto', border: '1px solid var(--etpos-border)', borderRadius: '8px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}><thead><tr>{['#', 'Contact ID', 'Name', 'Mobile', 'Email', 'Source', 'Value', 'Life Stage', 'Assigned To'].map((h, i) => (<th key={i} style={{ padding: '0.75rem 1rem', textAlign: 'left' }}>{h}</th>))}</tr></thead><tbody><tr><td colSpan={9} style={{ padding: '2.5rem', textAlign: 'center' }}>No data</td></tr></tbody></table>
              </div>
            </div>
          )}

          {activeTab === 'followups' && renderFollowupsTab()}
          {activeTab === 'campaigns' && renderCampaignsTab()}
          {activeTab === 'contacts_login' && renderContactsLoginTab()}
          {activeTab === 'commissions' && renderCommissionsTab()}
          {activeTab === 'reports' && renderReportsTab()}
          {activeTab === 'proposal_template' && renderProposalTemplateTab()}
          {activeTab === 'proposals' && renderProposalsTab()}
          {activeTab === 'sources' && renderSourcesTab()}
          {activeTab === 'life_stage' && renderLifeStageTab()}
          {activeTab === 'followup_category' && renderFollowupCategoryTab()}
          {activeTab === 'settings' && renderSettingsTab()}
        </div>
      </div>
      {showAddLeadModal && renderAddLeadModal()}
      {showAddFollowupModal && renderAddFollowupModal()}
      {showAddCampaignModal && renderAddCampaignModal()}
      {showFollowupFilters && renderFollowupFiltersModal()}
      {showAddContactLoginModal && renderAddContactLoginModal()}
      {showContactLoginFilters && renderContactLoginFiltersModal()}
      {showCommissionsFilters && renderCommissionsFiltersModal()}
      {showAddProposalTemplateModal && renderAddProposalTemplateModal()}
      {showSendProposalModal && renderSendProposalModal()}
      {showAddSourceModal && renderAddSourceModal()}
      {showAddLifeStageModal && renderAddLifeStageModal()}
      {showAddFollowupCategoryModal && renderAddFollowupCategoryModal()}
    </div>
  );
};

export default CRM;
